import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { removeUserRestaurant as removeUserRestaurantMutation } from "@/graphql/mutations";
import { removeUserRestaurantInRestaurants } from "./userRestaurantsState";

const client = generateClient();

export const userRemoveRestaurantState = create<State<boolean>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getRemoveRestaurantIsloading = () =>
  userRemoveRestaurantState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const getRemoveRestaurantIsError = (error: Error) =>
  userRemoveRestaurantState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getRemoveRestaurantIsSuccess = (queryResult: boolean) =>
  userRemoveRestaurantState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetRemoveUserRestaurantsState = () =>
  userRemoveRestaurantState.setState(() =>
    userRemoveRestaurantState.getInitialState()
  );


export const removeUserRestaurant = async (restaurantId: string) => {
  getRemoveRestaurantIsloading();

  try {
    const { data } = await client.graphql({
      query: removeUserRestaurantMutation,
      variables: {
        restaurantId
      }
    });

    getRemoveRestaurantIsSuccess(data.removeUserRestaurant);
    removeUserRestaurantInRestaurants(restaurantId);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to mutation removeUserRestaurant";
    getRemoveRestaurantIsError(Error(errorMessage));
  }
};
